import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getFoodCategoriesListRequest, getFoodCategoriesListRequestError, getFoodCategoriesListRequestSuccess } from "../../slices/Content/GetFoodCategoriesListSlice";


export const GetFoodCategoriesDropdownAPI = (type) => async (dispatch) => {
    try {
        dispatch(getFoodCategoriesListRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getFoodCategoriesDropdown,
            params: type,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getFoodCategoriesListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getFoodCategoriesListRequestError(_error));
            });
    } catch (error) { }
};
